const advanceLoadingStrings = {
  loadingTitle: 'Loading...',
  loadingDescription: 'Stay on this page and give us just a moment to wrap up',
};

export default advanceLoadingStrings;
